package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun HoldPersonMetadata() {
    SpellMetadata(
        spellIndex = "hold-person",
        castingTime = "1 action",
        range = "60 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A small, straight piece of iron.",
        duration = "Up to 1 minute",
        damageBase = null,
        damageScaling = null,
        savingThrow = "WIS (None)",
        aoe = null,
        concentration = true
    )
}
